<template>
  <div class="animated fadeIn uni-faculty">
    <vLoading v-if="vLoading" />
    <div v-if="$router.currentRoute.path == '/university/faculty'">
      <v-card class="common-card card-height">
        <v-row>
          <v-col class="pb-0">
            <h4 class="fs-xxlarge c-dark pt-2">مدیریت اعضای هیئت علمی</h4>
          </v-col>
          <v-col md="7" sm="8" class="pb-0">
            <div class="d-flex flex-row float-end">
              <v-text-field
                v-if="deviceType == 'desktop'"
                rounded
                filled
                class="search-box mt-2 mt-sm-0 me-5"
                placeholder="جستجو..."
                v-model="filter"
              >
                <template v-slot:prepend-inner>
                  <v-icon class="ps-3">$searchIcon</v-icon>
                </template>
              </v-text-field>
              <v-btn
                :to="'/university/dashboard'"
                class="bc-purple btn-radius no-underline"
                height="45"
                width="90"
                elevation="0"
              >
                <span class="fs-medium white--text">خانه</span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="deviceType == 'mobile'">
          <v-col>
            <v-text-field
              rounded
              filled
              class="search-box mt-2 mt-sm-0"
              placeholder="جستجو دراعضا..."
              v-model="filter"
            >
              <template v-slot:prepend-inner>
                <v-icon class="ps-3">$searchIcon</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-5">
          <v-col class="pb-0">
            <h4 v-if="!tableBusy" class="fs-xlarge c-dark pt-2">
              اعضا ({{ items.length }} نفر)
            </h4>
          </v-col>
          <v-col cols="5" class="text-left">
            <v-btn
              height="40"
              width="90"
              elevation="0"
              class="bc-white btn-border btn-radius"
              @click="openAddMemberDialog()"
            >
              <span class="fs-medium c-purple">افزودن</span>
            </v-btn>
          </v-col>
        </v-row>
        <div class="mt-6">
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :busy="tableBusy"
            @filtered="onFiltered"
            :filter-function="myFilterFn"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value ? data.value : "--" }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div
                style="text-align: center; vertical-align: middle"
                class="d-flex flex-row justify-content-center"
              >
                <div
                  @click="openDialog(data.item, 'edit')"
                  class="pointer pe-3 ps-0"
                >
                  <v-icon>$Edit</v-icon>
                </div>
                <div
                  @click="openDialog(data.item, 'delete')"
                  class="trash-icon pointer ps-3 pe-0"
                >
                  <v-icon>$Trash</v-icon>
                </div>
              </div>
            </template>
          </b-table>
          <v-row>
            <v-col>
              <v-pagination
                v-model="currentPage"
                :length="Math.ceil(totalRows / perPage)"
                :total-visible="5"
                prev-icon="arrow_back"
                next-icon="arrow_forward"
                class="float-end"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <v-dialog v-model="showImage" max-width="590">
        <v-card class="modal-card">
          <v-container class="text-center">
            <div class="image-box">
              <img :src="selected.src" />
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editMemberDialog" width="600">
        <v-card class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right pb-0">
                <h5 class="mt-1 c-dark fs-xxlarge">ویرایش اعضای هیئت علمی</h5>
              </v-col>
              <v-col class="text-left pb-0">
                <span @click="editMemberDialog = false">
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>
            <div class="text-right c-grey fs-small">
              موارد ستاره‌ دار را حتما پر کنید.
            </div>
            <div class="imageBox my-1">
              <img
                :src="
                  selectedMember.avatar
                    ? selectedMember.avatar
                    : 'data:avatar/png;base64,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'
                "
              />
              <div
                @click="
                  uploading = false;
                  addImageDialog = true;
                "
                class="edit-image bc-purple pointer"
              >
                <v-icon>$Pen</v-icon>
              </div>
            </div>
            <div class="textField-box pt-3">
              <v-text-field outlined rounded v-model="selectedMember.name">
                <template v-slot:label>
                  <div class="d-flex flex-row c-purple">
                    <span class="red--text pe-1">*</span> نام و نام خانوادگی
                  </div>
                </template>
              </v-text-field>
              <v-text-field
                outlined
                rounded
                type="number"
                v-model="selectedMember.natCode"
              >
                <template v-slot:label>
                  <div
                    :class="
                      checkNatCode(selectedMember.natCode)
                        ? 'c-purple'
                        : 'red--text'
                    "
                    class="d-flex flex-row c-purple"
                  >
                    <span class="red--text pe-1">*</span>
                    کد ملی
                  </div>
                </template>
              </v-text-field>
              <div
                v-if="!checkNatCode(selectedMember.natCode)"
                class="red--text fs-xsmall mb-4"
                style="margin-top: -15px"
              >
                کد ملی وارد شده صحیح نمی‌باشد!
              </div>
              <v-text-field outlined rounded v-model="selectedMember.degree">
                <template v-slot:label>
                  <div class="d-flex flex-row c-purple">
                    <span class="red--text pe-1">*</span> تحصیلات
                  </div>
                </template>
              </v-text-field>
              <v-text-field outlined rounded v-model="selectedMember.email">
                <template v-slot:label>
                  <div
                    class="d-flex flex-row"
                    :class="
                      validateEmail(selectedMember.email)
                        ? 'c-purple'
                        : 'red--text'
                    "
                  >
                    <span class="red--text pe-1">*</span> آدرس ایمیل
                  </div>
                </template>
              </v-text-field>
              <div
                v-if="!validateEmail(selectedMember.email)"
                class="red--text fs-xsmall mb-3"
                style="margin-top: -15px"
              >
                آدرس ایمیل وارد شده صحیح نمی‌باشد!
              </div>
            </div>
            <div>
              <v-btn
                class="bc-purple c-light"
                width="100"
                height="42"
                :disabled="
                  !selectedMember.name ||
                  !selectedMember.degree ||
                  !selectedMember.email ||
                  !selectedMember.natCode ||
                  !checkNatCode(selectedMember.natCode) ||
                  !validateEmail(selectedMember.email)
                "
                @click="editMember()"
                >تایید</v-btn
              >
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteMemberDialog" width="600">
        <v-card class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right">
                <h5 class="mt-1 c-dark fs-xxlarge">حذف از هیئت علمی</h5>
              </v-col>
              <v-col class="text-left">
                <span @click="deleteMemberDialog = false">
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>

            <div class="text-center my-5">
              <span class="c-dark fs-medium"
                >آیا از حذف
                <b>"{{ selectedMember.name }}"</b>
                از اعضای هیئت علمی اطمینان دارید؟</span
              >
            </div>
            <div class="text-center pt-3">
              <v-btn
                class="btn-border bc-white c-purple mx-2"
                width="100"
                height="42"
                elevation="0"
                @click="deleteMemberDialog = false"
                >لغو</v-btn
              >
              <v-btn
                class="bc-purple c-light mx-2"
                width="100"
                height="42"
                @click="deleteMember()"
                >تایید</v-btn
              >
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="addMemberDialog" width="600">
        <v-card class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right pb-0">
                <h5 class="mt-1 c-dark fs-xxlarge">افزودن عضو جدید</h5>
              </v-col>
              <v-col class="text-left pb-0">
                <span @click="addMemberDialog = false">
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>
            <div class="text-right c-grey fs-small">
              موارد ستاره‌ دار را حتما پر کنید.
            </div>
            <div class="imageBox my-1">
              <img
                :src="
                  uploadedFiles.url
                    ? uploadedFiles.url
                    : 'data:image/png;base64,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'
                "
              />
              <div
                @click="
                  uploading = false;
                  addImageDialog = true;
                "
                class="edit-image bc-purple pointer"
              >
                <v-icon>$Pen</v-icon>
              </div>
            </div>
            <div class="textField-box pt-3">
              <v-text-field outlined rounded v-model="newMember.name" required>
                <template v-slot:label>
                  <div class="d-flex flex-row c-purple">
                    <span class="red--text pe-1">*</span> نام و نام خانوادگی
                  </div>
                </template>
              </v-text-field>
              <v-text-field
                outlined
                rounded
                type="number"
                v-model="newMember.natCode"
              >
                <template v-slot:label>
                  <div
                    :class="
                      checkNatCode(newMember.natCode) ? 'c-purple' : 'red--text'
                    "
                    class="d-flex flex-row c-purple"
                  >
                    <span class="red--text pe-1">*</span>
                    کد ملی
                  </div>
                </template>
              </v-text-field>
              <div
                v-if="!checkNatCode(newMember.natCode)"
                class="red--text fs-xsmall mb-4"
                style="margin-top: -15px"
              >
                کد ملی وارد شده صحیح نمی‌باشد!
              </div>
              <v-text-field outlined rounded v-model="newMember.degree">
                <template v-slot:label>
                  <div class="d-flex flex-row c-purple">
                    <span class="red--text pe-1">*</span> تحصیلات
                  </div>
                </template>
              </v-text-field>
              <v-text-field outlined rounded v-model="newMember.email">
                <template v-slot:label>
                  <div
                    class="d-flex flex-row"
                    :class="
                      validateEmail(newMember.email) ? 'c-purple' : 'red--text'
                    "
                  >
                    <span class="red--text pe-1">*</span> آدرس ایمیل
                  </div>
                </template>
              </v-text-field>
              <div
                v-if="!validateEmail(newMember.email)"
                class="red--text fs-xsmall mb-3"
                style="margin-top: -15px"
              >
                آدرس ایمیل وارد شده صحیح نمی‌باشد!
              </div>
            </div>
            <div>
              <v-btn
                class="bc-purple c-light"
                width="100"
                height="42"
                :disabled="
                  !newMember.name ||
                  !newMember.degree ||
                  !newMember.email ||
                  !newMember.natCode ||
                  !checkNatCode(newMember.natCode) ||
                  !validateEmail(newMember.email)
                "
                @click="addMember()"
                >تایید</v-btn
              >
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="addImageDialog" width="400">
        <v-card class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right">
                <h5 class="mt-1 c-dark fs-xlarge">آپلود تصویر</h5>
              </v-col>
              <v-col cols="2" class="text-left">
                <span @click="addImageDialog = false">
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>
            <div
              v-if="!uploading"
              class="upload-box"
              @dragover="dragover"
              @dragleave="dragleave"
              @drop="drop"
            >
              <p class="c-grey fs-large mb-2">
                فایل مورد نظر را به این قسمت بکشید
              </p>
              <p class="c-grey fs-large mb-2">یا</p>
              <v-btn
                @click="$refs.upload.$refs.input.click()"
                class="upload-btn"
                height="42"
                >یافتن فایل</v-btn
              >
            </div>
            <div v-else>
              <div class="d-flex flex-row w-100">
                <div>
                  <v-icon class="mt-2" large>$File</v-icon>
                </div>
                <div class="w-100 px-3">
                  <p class="mb-0">در حال بارگذاری تصویر...</p>
                  <v-progress-linear
                    class="mt-1"
                    outlined
                    height="4"
                    :value="myFile.uploadPercentage"
                    color="#93329e"
                  >
                  </v-progress-linear>
                </div>
                <div class="c-purple pt-4">{{ myFile.uploadPercentage }}%</div>
              </div>
              <div class="mt-6">
                <v-btn
                  @click="addImage()"
                  color="#93329e"
                  class="c-light"
                  width="100"
                  height="42"
                  :disabled="myFile.uploadPercentage != 100"
                  >تایید</v-btn
                >
              </div>
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <v-file-input
        @change="myUpload(file)"
        v-model="file"
        ref="upload"
        outlined
        dense
        v-show="false"
      ></v-file-input>
    </div>
  </div>
</template>

<script>
function checkCodeMeli(code) {
  //NOTE employee's checking validation of national code
  var L = code.length;

  if (L < 8 || parseInt(code, 10) == 0) return false;
  code = ("0000" + code).substr(L + 4 - 10);
  if (parseInt(code.substr(3, 6), 10) == 0) return false;
  var c = parseInt(code.substr(9, 1), 10);
  var s = 0;
  for (var i = 0; i < 9; i++) s += parseInt(code.substr(i, 1), 10) * (10 - i);
  s = s % 11;
  return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
  return true;
}
export default {
  data() {
    return {
      uploadedFiles: [],
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      image: [],
      filter: "",
      selected: {},
      showImage: false,
      vLoading: false,
      editMemberDialog: false,
      deleteMemberDialog: false,
      addImageDialog: false,
      addMemberDialog: false,
      selectedMember: {},
      newMember: {},
      deviceType: "",
      uploading: false,
      items: [],
      currentPage: 1,
      totalRows: "",
      perPage: 10,
      tableBusy: false,
      filter: "",
      fields: [
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "natCode", label: "کد ملی" },
        { key: "degree", label: "تحصیلات" },
        { key: "email", label: "آدرس ایمیل" },
        { key: "operation", label: "عملیات" },
      ],
    };
  },
  methods: {
    openDialog(item, type) {
      this.selectedMember = JSON.parse(JSON.stringify(item));
      if (type == "edit") {
        this.editMemberDialog = true;
      }
      if (type == "delete") {
        this.deleteMemberDialog = true;
      }
    },
    openAddMemberDialog() {
      this.addMemberDialog = true;
      this.newMember = {};
      this.uploadedFiles = [];
      this.selectedMember = {};
    },
    checkNatCode(id) {
      // NOTE (m-isID) to check the validity of the national code
      return id ? (checkCodeMeli(id) ? true : false) : true;
    },
    editMember() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/university/profile/editScienceCommittee",
          {
            scienceCommitteeId: this.selectedMember.id,
            name: this.selectedMember.name,
            natCode: this.selectedMember.natCode,
            degree: this.selectedMember.degree,
            email: this.selectedMember.email,
            avatarId: this.uploadedFiles ? this.uploadedFiles.id : "",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.editMemberDialog = false;
          this.toast(res.data, "success");
          this.vLoading = false;
          this.getFaculty();
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    deleteMember() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/university/profile/removeScienceCommittee",
          {
            scienceCommitteeId: this.selectedMember.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.deleteMemberDialog = false;
          this.toast(res.data, "success");
          this.vLoading = false;
          this.getFaculty();
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    addMember() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/university/profile/addScienceCommittee",
          {
            avatarId: this.uploadedFiles ? this.uploadedFiles.id : "",
            name: this.newMember.name,
            natCode: this.newMember.natCode,
            degree: this.newMember.degree,
            email: this.newMember.email,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.addMemberDialog = false;
          this.toast(res.data, "success");
          this.getFaculty();
          this.vLoading = false;
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    addImage() {
      //this.vLoading = true;
      //   this.$http
      //       .post(
      //         this.baseUrl + "",
      //         {
      //             this.role =='company' ? companyId: '' : uniId: ''
      //             image: this.uploadedFiles[0].id
      //          },
      //         {
      //           headers: {
      //             Authorization: "Bearer: " + localStorage.getItem("userId")
      //           }
      //         }
      //       )
      //       .then(res => {
      //         this.deleteMemberDialog = false;
      //         this.toast(res.data, "success");
      //         this.getFaculty()
      //       })
      //       .catch(err => {
      //         this.vLoading = false;
      //         if (err.response.status == 403)
      //           // this.$router.replace("/unauthorize");
      //           this.$router.push({
      //             path: "/login",
      //             query: { return: window.location.pathname }
      //           });
      //       });
    },
    getFaculty() {
      this.tableBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/university/profile/scienceCommittees",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.totalRows = this.items.length;
          this.tableBusy = false;
        })
        .catch((err) => {
          this.tableBusy = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    myUpload(file) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد.", "error");
        return;
      } else {
        this.uploading = true;

        // START UPLOAD PROCESS
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(this.baseUrl + "/setad/university/profile/upload", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
            onUploadProgress: ((progressEvent) => {
              this.myFile.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((res) => {
            if (res.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.uploadedFiles = res.data;
              this.addImageDialog = false;
              if (this.selectedMember) {
                this.selectedMember.avatar = this.uploadedFiles.url;
              }
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.uploadedFiles = {};
            this.additionalFiles.contract = {};
            this.myFile.uploadPercentage = 0;
          });
      }
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      // if (!event.currentTarget.classList.contains("bg-green-300")) {
      //   event.currentTarget.classList.remove("bg-gray-100");
      //   event.currentTarget.classList.add("bg-green-300");
      // }
    },
    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      event.preventDefault();
      this.file = event.dataTransfer.files;
      if (Array.from(this.file).length) {
        if (Array.from(this.file).length > 1) {
          this.toast(
            " در این بخش شما مجاز به آپلود بیش از یک عکس نمی‌باشید.",
            "error"
          );
          return;
        }
        Array.from(this.file).forEach((file) => {
          this.myUpload(file);
        });
      }
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    validateEmail(email) {
      //NOTE checking validation of email
      if (email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase()) ? true : false;
      } else return true;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    myFilterFn(item, filter) {
      if (
        item.name.includes(filter) ||
        item.email.includes(filter) ||
        item.degree.includes(filter) ||
        item.natCode.includes(filter)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    if (window.screen.width < 850) {
      this.deviceType = "mobile";
    } else {
      if (document.body.clientWidth < 850) {
        this.deviceType = "mobile";
      } else {
        this.deviceType = "desktop";
      }
    }
    this.getFaculty();
  },
};
</script>
<style lang="scss">
.modal-card {
  border-radius: 10px !important;
  img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .textField-box {
    .v-text-field .v-input__slot,
    .v-text-field fieldset {
      border-radius: 6px !important;
      border-color: #93329e !important;
    }
    .v-input__slot {
      margin-bottom: 25px;
      input {
        color: #656a81 !important;
      }
      .v-text-field__suffix {
        color: #656a81 !important;
      }
    }
  }
  .v-label {
    font-size: 0.9rem !important;
    color: #93329e !important;
    background-color: #fff;
    padding: 1px 10px;
    margin-bottom: 0 !important;
    height: 25px;
    transform: translateY(-31px);
  }
  .imageBox {
    position: relative;
    width: fit-content;
    margin: 0 auto;
    img {
      width: 100px;
      height: 100px;
      border-radius: 50%;
    }
    .edit-image {
      position: absolute;
      bottom: 3px;
      right: 0px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      svg {
        transform: translate(2px, 13px) !important;
      }
      path {
        stroke: #fff;
      }
    }
  }
}
</style>
